export default {
	GET_TEMPLATE: '/document-service/templates',
	GET_DOCUMENT: '/document-service/documents/byFileUniqueId',
	GET_DOCUMENT_LOCKS: '/document-service/documents/locks',
	DOWNLOAD_DOCUMENT (lecomBpmUrl = '', processIds = {}, gridIdentifier = '', fileUniqueId = '') {
		const isBar = lecomBpmUrl ? lecomBpmUrl[lecomBpmUrl.length - 1] === '/' : false;
		const gridId = gridIdentifier !== '' ? `/grids/${gridIdentifier}` : '';

		return `${lecomBpmUrl}${isBar ? '' : '/'}bpm/api/v1/process-instances/${processIds.processInstanceId || ''}/activity-instances/${processIds.activityInstanceId || ''}/cycles/${processIds.cycle || ''}${gridId}/documents/files/${fileUniqueId}/download`;

	},
	CREATE_DOCUMENT: '/document-service/documents/create',
	IMPORT_DOCUMENT (lecomBpmUrl = '', processIds = {}, gridIdentifier = '', fieldName = '') {
		const isBar = lecomBpmUrl ? lecomBpmUrl[lecomBpmUrl.length - 1] === '/' : false;
		const gridId = gridIdentifier !== '' ? `/grids/${gridIdentifier}` : '';

		return `${lecomBpmUrl}${isBar ? '' : '/'}bpm/api/v2/process-instances/${processIds.processInstanceId || ''}/activity-instances/${processIds.activityInstanceId || ''}/cycles/${processIds.cycle || ''}${gridId}/fields/${fieldName}/documents/import`;
	},
	CHECKOUT_DOCUMENT: '/document-service/documents/checkout',
	CHECKIN_DOCUMENT(lecomBpmUrl = '', params = {}, checkinUrlType) {
		const isBar = lecomBpmUrl ? lecomBpmUrl[lecomBpmUrl.length - 1] === '/' : false;
		const url = `/api/v2/process-instances/${params.processInstanceId}/activity-instances/${params.activityInstanceId}/cycles/${params.cycle}`	
		return `${lecomBpmUrl}${isBar ? '' : '/'}bpm${url}${checkinUrlType(params.gridIdentifier, params.gridRowIndex, params.fieldName, params.documentId)}`;	
	},
	DETACH_DOCUMENT: '/document-service/documents/detach',
	DELETE_DOCUMENT: '/document-service/documents/delete',
	GET_DOCUMENT_VERSIONS: '/document-service/documents/versions',
	CANCEL_CHECKOUT_DOCUMENT: '/document-service/documents/cancelCheckout',
	CHECK_DOCUMENT_CAN_BE_DELETED: '/document-service/documents/canDelete',

	//TODO - novas rotas para assinatura digital

	POST_DIGITAL_SIGNATURE_ECM_CORE_TOKEN (token = ''){
		return `/ecmcore/api/v1/sign/${token}`;
	},
	PUT_CANCEL_SIGN_ACTION (token = ''){
		return `/ecmcore/api/v1/sign/${token}/cancel`;
	},

	GET_FIELD_ID(gatewayUrl = '', processInstanceData = {}){
		const isBar = gatewayUrl ? gatewayUrl[gatewayUrl.length - 1] === '/' : false;
		return `${gatewayUrl}${isBar ? '' : '/'}bpm/api/v2/process-definitions/${processInstanceData.processId}/versions/${processInstanceData.version}/fields`;
	},

	GET_PERMISSION_DIGITAL_SIGNATURE (gatewayUrl = ''){
		const isBar = gatewayUrl ? gatewayUrl[gatewayUrl.length - 1] === '/' : false;
		return `${gatewayUrl}${isBar ? '' : '/'}bpm/api/v1/sign/permission`
	},

	POST_CREATE_TOKEN_DIGITAL_SIGNATURE (gatewayUrl = '', fileUniqueId = ''){
		const isBar = gatewayUrl ? gatewayUrl[gatewayUrl.length - 1] === '/' : false;
		return `${gatewayUrl}${isBar ? '' : '/'}ecmcore/api/v1/sign/${fileUniqueId}/token`;
	},

	GET_STATUS_DIGITAL_SIGNATURE (gatewayUrl = '', token = ''){
		const isBar = gatewayUrl ? gatewayUrl[gatewayUrl.length - 1] === '/' : false;
		return `${gatewayUrl}${isBar ? '' : '/'}ecmcore/api/v1/sign/${token}/status`;
	},

	PUT_LOOCK_FIELD_DOCUMENT (gatewayUrl = '', processIds = {}, fieldName = '', fileUniqueId = ''){
		const isBar = gatewayUrl ? gatewayUrl[gatewayUrl.length - 1] === '/' : false;
		return `${gatewayUrl}${isBar ? '' : '/'}bpm/api/v1/process-instances/${processIds.processInstanceId || ''}/activity-instances/${processIds.activityInstanceId || ''}/cycles/${processIds.cycle || ''}/fields/${fieldName}/documents/${fileUniqueId}/lock`;
	},

	PUT_LOOCK_GRID_DOCUMENT (gatewayUrl = '', processIds = {}, gridIdentifier = '', fieldName = '', fileUniqueId = ''){
		const isBar = gatewayUrl ? gatewayUrl[gatewayUrl.length - 1] === '/' : false;
		const gridId = gridIdentifier !== '' ? `/grids/${gridIdentifier}` : '';

		return `${gatewayUrl}${isBar ? '' : '/'}bpm/api/v1/process-instances/${processIds.processInstanceId || ''}/activity-instances/${processIds.activityInstanceId || ''}/cycles/${processIds.cycle || ''}/grids/${gridId}/fields/${fieldName}/documents/${fileUniqueId}/lock`;
	},

	PUT_LOOCK_GRID_ROW_DOCUMENT (gatewayUrl = '', processIds = {}, gridIdentifier = '', gridRowIndex = '', fieldName = '', fileUniqueId = ''){
		const isBar = gatewayUrl ? gatewayUrl[gatewayUrl.length - 1] === '/' : false;
		return `${gatewayUrl}${isBar ? '' : '/'}bpm/api/v1/process-instances/${processIds.processInstanceId || ''}/activity-instances/${processIds.activityInstanceId || ''}/cycles/${processIds.cycle || ''}/grids/${gridIdentifier}/rows/${gridRowIndex}/fields/${fieldName}/documents/${fileUniqueId}/lock`
	},

	PREVIEW_DOCUMENT (lecomBpmUrl = '', params = {}) {
		const isBar = lecomBpmUrl ? lecomBpmUrl[lecomBpmUrl.length - 1] === '/' : false;		
		return `${lecomBpmUrl}${isBar ? '' : '/'}bpm/api/v1/process-instances/${params.processInstanceId || ''}/activity-instances/${params.activityInstanceId || ''}/cycles/${params.cycle || ''}/documents/files/${params.fileUniqueId}/view`;
	},
};
